import { render, staticRenderFns } from "./TrainingMenu.vue?vue&type=template&id=0f26a580&scoped=true"
import script from "./TrainingMenu.vue?vue&type=script&lang=ts"
export * from "./TrainingMenu.vue?vue&type=script&lang=ts"
import style0 from "./TrainingMenu.vue?vue&type=style&index=0&id=0f26a580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f26a580",
  null
  
)

export default component.exports